import(/* webpackMode: "eager" */ "/tmp/builds/BTBXM2ssK/1/ciorg/supporter/web/sola/apps/skippy-serve/src/app/global-error.tsx");
